import { cn } from "../../../lib/utils";
import HorizontalScroll from "../../common/HorizontalScroll";
import DashboardSection from "./DashboardSection";

export default function TopAreaTable() {
  const tableHeads = ["Tag ID", "Unit", "Type", "Health", "Status", "Details"];
  return (
    <DashboardSection
      title="Asset Health"
      containerClassName=""
      className="overflow-y-auto"
    >
      <HorizontalScroll
        className="w-full max-h-[322px]"
        overflow="overflow-auto"
        isShowScrollBar={true}
      >
        {" "}
        <table className="table-auto text-[#242424] text-xs w-full border-collapse max-h-[351px] overflow-auto custom-scrollbar border border-[#B9B9B9]/30 border-t-0">
          <thead className="sticky top-0 z-10 bg-white">
            <tr className="divide-x divide-[#B9B9B9]/30">
              {tableHeads.map((head, index) => (
                <th key={index}>
                  <div className="border-[#B9B9B9]/30 border-t py-[10.5px] bg-white ">
                    {head}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {new Array(10).fill(0).map((item, index) => (
              <tr
                className={cn(
                  "bg-[#eaeaea] divide-x divide-[#B9B9B9]/30 border-t border-[#B9B9B9]/30",
                  {
                    "bg-[#F1F1F1]": index % 3 === 2,
                  }
                )}
                key={index}
              >
                <TD>9-T101</TD>
                <TD>Unit 9</TD>
                <TD>Compressor</TD>
                <TD>64.9%</TD>
                <TD>
                  <div
                    className={cn("size-[15px] rounded-full", {
                      "bg-[#FFA600]": index % 3 === 2,
                      "bg-[#DC1111]": index % 3 === 1,
                      "bg-[#11DC3D]": index % 3 === 0,
                    })}
                  ></div>
                </TD>
                <TD className="w-[143px]">
                  <div className="bg-[#EDF0FB] flex justify-center items-center px-2.5 border-[#c9c9c9] border-[0.5px] h-[22px] rounded-[4px]">
                    spec
                  </div>
                  <div className="bg-[#EDF0FB] flex justify-center items-center px-2.5 border-[#c9c9c9] border-[0.5px] h-[22px] rounded-[4px]">
                    3D
                  </div>
                </TD>
              </tr>
            ))}
          </tbody>
        </table>
      </HorizontalScroll>
    </DashboardSection>
  );
}

const TD = ({ children, className }) => {
  return (
    <td>
      <div
        className={`py-2 text-xs leading-[100%] flex justify-center items-center gap-2.5 px-4 mx-auto ${className}`}
      >
        {children}
      </div>
    </td>
  );
};
